import { render, staticRenderFns } from "./MapComponent.vue?vue&type=template&id=22452378&scoped=true&"
import script from "./MapComponent.vue?vue&type=script&lang=js&"
export * from "./MapComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22452378",
  null
  
)

export default component.exports